import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/UserFollow.svg'

export const IconUserFollow = IconSVG as IconComponent
